import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onKeyDown = (e) => {
      if (e.key !== "Enter") return
      if (e.isComposing) return

      const el = e.target
      const tag = el?.tagName?.toLowerCase()

      // Allow Enter in textarea (and contenteditable), block in normal inputs
      if (tag === "textarea" || el?.isContentEditable) return

      // If you ever add "Enter submits" buttons, don't block those
      if (tag === "button") return

      e.preventDefault()
    }

    this.element.addEventListener("keydown", this._onKeyDown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this._onKeyDown)
  }
}
